export function limitString(value: string, charLimit: number, limitChar: string = '...') {
    if (!value) {
        return '';
    }

    return value.length > charLimit ? value.substring(0, charLimit) + '...' : value;
}